export default __webpack_public_path__ + "static/Hero_Officers-a61854e1e5c538dcb6681dc03e4f79e7.jpg";